
export const newsData = [
  {
    id: 1,
    category: 'Literatura',
    title: 'Das Schloß (1926)',
    author: 'Franz Kafka',
    date: '2025-09-05',
    source: 'openlibrary',
    email: 'roiz_fernandez@yahoo.com',
    excerpt: 'Una obra maestra del siglo XX que explora temas de alienación y burocracia a través de la narrativa surrealista de Kafka.'
  },
  {
    id: 2,
    category: 'Literatura',
    title: 'Robin Hood (1883)',
    author: 'Howard Pyle',
    date: '2025-08-28',
    source: 'openlibrary',
    email: 'literatura_clasica@gmail.com',
    excerpt: 'La legendaria historia del arquero de Sherwood Forest, contada con la maestría narrativa de Pyle.'
  },
  {
    id: 3,
    category: 'Teatro',
    title: 'Hamlet: Nueva Interpretación Contemporánea',
    author: 'William Shakespeare',
    date: '2025-09-12',
    source: 'teatro_moderno',
    email: 'teatro@vintage.com',
    excerpt: 'Una nueva puesta en escena de la obra más famosa de Shakespeare que desafía las interpretaciones tradicionales.'
  },
  {
    id: 4,
    category: 'Noticias',
    title: 'Descubrimiento de Manuscritos Perdidos del Siglo XVIII',
    author: 'Dr. Elena Vásquez',
    date: '2025-09-15',
    source: 'archivo_nacional',
    email: 'investigacion@archivo.gov',
    excerpt: 'Hallazgo extraordinario en la Biblioteca Nacional revela textos inéditos de autores del período ilustrado.'
  },
  {
    id: 5,
    category: 'Blog',
    title: 'La Influencia del Romanticismo en la Literatura Actual',
    author: 'Prof. Carlos Mendoza',
    date: '2025-09-10',
    source: 'universidad_literatura',
    email: 'cmendoza@univ.edu',
    excerpt: 'Análisis profundo sobre cómo los ideales románticos siguen moldeando la narrativa contemporánea.'
  },
  {
    id: 6,
    category: 'Literatura',
    title: 'Don Quijote: 400 Años de Vigencia',
    author: 'Miguel de Cervantes',
    date: '2025-09-08',
    source: 'cervantes_institute',
    email: 'quijote@cervantes.org',
    excerpt: 'Reflexión sobre la eternidad de la obra cervantina y su relevancia en el mundo moderno.'
  },
  {
    id: 7,
    category: 'Poesía',
    title: 'Veinte Poemas de Amor y una Canción Desesperada',
    author: 'Pablo Neruda',
    date: '2025-09-13',
    source: 'fundacion_neruda',
    email: 'poesia@neruda.org',
    excerpt: 'Una de las obras poéticas más influyentes del siglo XX, donde Neruda explora el amor y la pérdida con una sensibilidad extraordinaria.'
  },
  {
    id: 8,
    category: 'Poesía',
    title: 'Antología de Poesía Española del Siglo de Oro',
    author: 'Francisco de Quevedo',
    date: '2025-09-11',
    source: 'biblioteca_nacional',
    email: 'quevedo@clasicos.es',
    excerpt: 'Selección de los mejores sonetos y décimas del maestro barroco, que reflejan la complejidad del alma humana.'
  },
  {
    id: 9,
    category: 'Ensayo',
    title: 'El Laberinto de la Soledad: Reflexiones sobre México',
    author: 'Octavio Paz',
    date: '2025-09-14',
    source: 'fondo_cultura',
    email: 'paz@ensayo.mx',
    excerpt: 'Profundo análisis sobre la identidad mexicana y latinoamericana, una obra fundamental del pensamiento contemporáneo.'
  },
  {
    id: 10,
    category: 'Ensayo',
    title: 'Sobre la Brevedad de la Vida',
    author: 'Séneca',
    date: '2025-09-09',
    source: 'filosofia_clasica',
    email: 'seneca@filosofia.org',
    excerpt: 'Reflexiones atemporales del filósofo estoico sobre el valor del tiempo y la importancia de vivir conscientemente.'
  },
  {
    id: 11,
    category: 'Poesía',
    title: 'Residencia en la Tierra: Ciclo Completo',
    author: 'Pablo Neruda',
    date: '2025-09-06',
    source: 'editorial_catedra',
    email: 'residencia@poesia.cl',
    excerpt: 'La evolución poética de Neruda a través de sus tres libros de Residencia, donde desarrolla su estilo surrealista más personal.'
  },
  {
    id: 12,
    category: 'Ensayo',
    title: 'Los Ensayos: Sabiduría y Experiencia',
    author: 'Michel de Montaigne',
    date: '2025-09-07',
    source: 'renaissance_studies',
    email: 'montaigne@ensayos.fr',
    excerpt: 'El creador del género ensayístico moderno nos ofrece reflexiones íntimas sobre la condición humana y el conocimiento de uno mismo.'
  }
];